import { rem } from '@mantine/core';
import ShadeGeneratorLib, { type IShadeGenerator, type Shade } from 'shade-generator';

import { getBrand } from '../utils/brand';

// @ts-expect-error Tailwindcss have problems loading default exports, we need to
// make sure to use the default export of shade-generator
const ShadeGenerator: IShadeGenerator = ShadeGeneratorLib.default || ShadeGeneratorLib;

/* Same as tailwindcss default breakpoints */
export const breakpoints = {
  sm: '40em', // 640px
  md: '48em', // 768px
  lg: '64em', // 1024px
  xl: '80em', // 1280px
  '2xl': '96em', // 1536px
};

const themes = {
  start: {
    primary: createColorArray('#cb242a'), // Primary red
    secondary: createColorArray('#1a1a1a'), // Secondary black
    accent: createColorArray('#ffffff'), // Accent white
    green: createColorArray('#15c15d'), // Success color
    yellow: createColorArray('#f59e0b'), // Warning color
    blue: createColorArray('#3b82f6'), // Info color
    red: createColorArray('#ef4444'), // Error color
    light: createColorArray('#ffffff'), // White background
    dark: createColorArray('#1a1a1a'), // Black text
    gray: createColorArray('#6b7280'), // Neutral gray
    authPrimary: createColorArray('#cb242a'), // Primary red
    authSecondary: createColorArray('#1a1a1a'), // Secondary black
  },
  sttart: {
    primary: createColorArray('#d52b1e'), // Site primary red
    secondary: createColorArray('#1d1d1b'), // Secondary black
    accent: createColorArray('#ffffff'), // Anti-Flash White
    green: createColorArray('#15c15d'), // Success color
    yellow: createColorArray('#f59e0b'), // Warning color
    blue: createColorArray('#3b82f6'), // Info color
    red: createColorArray('#ef4444'), // Error color
    light: createColorArray('#ececec'), // Anti-Flash White background
    dark: createColorArray('#1d1d1b'), // Black text
    gray: createColorArray('#6b7280'), // Neutral gray
    authPrimary: createColorArray('#1d1d1b'), // Secondary black
    authSecondary: createColorArray('#79130a'), // Primary red
  },
} as const;

const brand = getBrand();
export const colors = themes[brand];

export const spacings = {
  xs: rem(4),
  sm: rem(8),
  md: rem(16),
  lg: rem(24),
  xl: rem(32),
};

export const fontSize = {
  xs: rem(12),
  sm: rem(14),
  md: rem(16),
  lg: rem(18),
  xl: rem(20),
};

// Function to create an array of 10 different shades of a color
function createColorArray(color: string) {
  const config: Record<Shade, number> = {
    '10': 0,
    '20': 0,
    '30': 0,
    '40': 0.9,
    '50': 0.75,
    '60': 0.6,
    '70': 0.45,
    '80': 0.3,
    '90': 0.15,
    '100': 0,
    '200': 0.9,
    '300': 0.8,
    '400': 0.7,
    '500': 0,
    '600': 0,
    '700': 0,
    '800': 0,
    '900': 0,
    '1000': 0,
  };

  const colorMap = ShadeGenerator.hue(color).config(config).shadesMap('rgba');
  const colors = [
    colorMap['40'],
    colorMap['50'],
    colorMap['60'],
    colorMap['70'],
    colorMap['80'],
    colorMap['90'],
    colorMap['100'],
    colorMap['200'],
    colorMap['300'],
    colorMap['400'],
  ] as const;

  return colors;
}
